export default "__VITE_ASSET__CE2tyFsG__ 1200w";